<div id="forgetpassword" fxLayout="column">
    <div id="forgetpassword-form-wrapper" fxLayout="column" fxLayoutAlign="center center">
        <div id="forgetpassword-form" [@animate]="{value:'*',params:{duration:'300ms',y:'100px'}}">
            <div class="logo">
                <img src="../../../../assets/images/logo/giant2.png">
            </div>
            <div class="title">Forgot password</div>
            <div class="title">We have sent you an email with password reset code. Please provide that reset code to continue</div>
            <form name="resetCodeForm" [formGroup]="resetCodeForm" novalidate>

                <mat-form-field appearance="outline">
                    <mat-label>Password reset code</mat-label>
                    <input matInput formControlName="passwordResetCode">
                    <mat-error *ngIf="resetCodeForm.get('passwordResetCode').hasError('required')"> Reset password
                        code is required </mat-error>
                    <mat-error
                        *ngIf="!resetCodeForm.get('passwordResetCode').hasError('required') && resetCodeForm.get('passwordResetCode').hasError('passwordResetCode')">
                        Reset password code is required
                    </mat-error>
                </mat-form-field>

                <button mat-raised-button color="accent" class="submit-button" aria-label="Forget password"
                    [disabled]="resetCodeForm.invalid" (click)="VerifyResetCode(resetCodeForm)">
                    Submit
                </button>
            </form>
        </div>

    </div>

</div>